export const IS_FIREFOX = navigator.userAgent.toLowerCase().indexOf("firefox") > -1
export const IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
